export function useComponentVisibility() {
    return {
        getComponentVisability(component_id) {
            return axios.get('api/get-component-visibility', {
                params: {
                    component_id: component_id
                }
            })
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    return response.data;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden",
                        e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data",
                        "error"
                    );
                });
        },
        updateComponentVisability(component_id, isVisible) {
            return axios.get('api/update-component-visability', {
                params: {
                    component_id: component_id,
                    is_visable: isVisible
                }
            });
        }
    };
}
